// import {initNimSDK} from './initNimSDK'
// import {updateFriend, addFriend, deleteFriend} from './friends'
// import {deleteSession, setCurrSession, resetCurrSession} from './session'
// import {sendMsg, sendFileMsg, sendMsgReceipt, sendRobotMsg, revocateMsg, updateLocalMsg, getHistoryMsgs, resetNoMoreHistoryMsgs, continueRobotMsg} from './msgs'
// import {markSysMsgRead, resetSysMsgs, deleteSysMsgs, markCustomSysMsgRead} from './sysMsgs'

export default {
  //判断登录
  isLogin({
    dispatch,
    commit
  }, obj) {
    const that = this
    return new Promise(function (resolve, reject) {
      if (window.localStorage.getItem('jwt_token') == null || window.localStorage.getItem('uname') == null) {
        // window.location.href = 'http://mu.eguowang.com/api3/login/authorize'
        return false;
      }
    })
  },
  //token失效 清除token
  refreshToken({
    dispatch,
    commit
  }, obj) {
    return new Promise(function (resolve, reject) {
      window.localStorage.removeItem('jwt_token');
      window.localStorage.removeItem('uname');
      commit('refreshToken');
      dispatch('isLogin')
    })
  },
  // 登录成功后保存token
  logined({
    dispatch,
    commit
  }, obj) {
    return new Promise(function (resolve, reject) {
      var backUrl = window.localStorage.getItem('routePath');
      commit('logined', obj)
      window.localStorage.setItem('jwt_token', obj.jwt_token);
      window.localStorage.setItem('uname', obj.uname);
      // router.replace(backUrl)
    })
  },
  getyunxin({
    dispatch,
    commit
  }, obj){
    return new Promise(function (resolve, reject){
      commit('getyunxin', obj)
      window.localStorage.setItem('yunxin_json', JSON.stringify(obj));
    })
  },
  //设置分享uname
  refreshShareUname({
    dispatch,
    commit
  }, obj) {
    return new Promise(function (resolve, reject) {
      window.localStorage.setItem('share_uname', obj);
      commit('refreshShareUname', obj);
      dispatch('isLogin')
    })
  },
  //刷新获取本地缓存token
  getLocalToken({
    dispatch,
    commit
  }, obj) {
    return new Promise(function (resolve, reject) {
      commit('getLocalToken', obj)
    })
  },
  //更新菜单开启状态
  refreshMenuOpenStatus({
    dispatch,
    commit
  }, obj) {
    return new Promise(function (resolve, reject) {
      commit('refreshMenuOpenStatus', obj);
    })
  },
  //更新手机绑定状态
  refreshBindPhoneStatus({
    dispatch,
    commit
  }, obj) {
    return new Promise(function (resolve, reject) {
      commit('refreshBindPhoneStatus', obj);
    })
  },
  //判断是否为iphonex
  is_iphoneX({
    dispatch,
    commit
  }, obj) {
    return new Promise(function (resolve, reject) {
      // iPhone X、iPhone XS
      var isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812;
      // iPhone XS Max
      var isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896;
      // iPhone XR
      var isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896;
      if (isIPhoneX || isIPhoneXSMax || isIPhoneXR) {
        commit('is_iphoneX', true);
      } else {
        commit('is_iphoneX', false);
      }
    })
  },


updateUserInfo({commit},obj){
    commit('updateUserInfo',obj)
  },

  // updateRefreshState ({commit}) {
  //   commit('updateRefreshState')
  // },

  // UI 及页面状态变更
  // showLoading,
  // hideLoading,
  // showFullscreenImg,
  // hideFullscreenImg,
  // continueRobotMsg,

  // 连接sdk请求，false表示强制重连
  // connect (store, obj) {
  //   connectNim(store, obj)
  // },
}



// WEBPACK FOOTER //
// ./src/store/actions/index.js